import * as React from 'react'
import { SubTitle, Title, TitleGroup } from './style'

export default ({
  title,
  subtitle,
  needsRightSpace = false,
  isHorizontal = false,
}) => (
  <TitleGroup needsRightSpace={needsRightSpace} isHorizontal={isHorizontal}>
    <Title>{title}</Title>
    <SubTitle title={subtitle}>{subtitle}</SubTitle>
  </TitleGroup>
)
